<template>
  <div class="auth-wrapper-provider">
    <b-form @submit.prevent="submit" class="flex-center">
      <AuthWrapper
        v-if="successUploaded"
        rightIcon="arrow-right"
        :label="$lang.guidance"
        @handleRightIcon="goToLogin"
      >
        <template #main>
          <b-row>
            <b-col
              cols="12"
              md="12"
              class="margin-bottom-24 font-size-12 color-complementary-300 text-justify"
            >
              {{ $lang.support_message_text }}
            </b-col>

            <b-col cols="12" md="12">
              <div class="font-size-12 color-complementary-300 margin-bottom-8">
                {{ $lang.support_code }}
              </div>
              <div
                class="flex-center height-48 border-radius-8 border--dashed border--complementary-200 cursor--pointer"
                @click="copy(trackingCode, true)"
              >
                <span
                  class="font-size-16 color-complementary-300 margin-left-8 margin-top-4"
                >
                  {{ trackingCode }}
                </span>
                <span class="color-complementary-200">
                  <mdicon name="content-copy" size="24" />
                </span>
              </div>
            </b-col>
          </b-row>
        </template>
      </AuthWrapper>
      <AuthWrapper
        v-else
        rightIcon="arrow-right"
        :label="$lang.guidance"
        @handleRightIcon="goToLogin"
      >
        <template #main>
          <b-row>
            <b-col cols="12" md="12" class="margin-bottom-24">
              <Alert :text="$lang.message_before_login" />
            </b-col>
            <b-col cols="12" md="12">
              <Input
                :label="$lang.name"
                :placeholder="$lang.name"
                :value="form.name"
                name="name"
                id="name"
                type="text"
                :minLength="lengthNumber3"
                :maxLength="lengthNumber64"
                :vuelidateObj="$v.form.name"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12" md="12">
              <Input
                :label="$lang.family"
                :placeholder="$lang.family"
                :value="form.family"
                name="family"
                id="family"
                type="text"
                :minLength="lengthNumber3"
                :maxLength="lengthNumber64"
                :state="$v.form.family.$dirty ? !$v.form.family.$error : null"
                :vuelidateObj="$v.form.family"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12" md="12">
              <Input
                :label="$lang.mobile"
                :placeholder="$lang.mobile"
                :value="form.mobile"
                name="mobile"
                id="mobile"
                type="tel"
                :minLength="lengthNumber11"
                :maxLength="lengthNumber11"
                :state="$v.form.mobile.$dirty ? !$v.form.mobile.$error : null"
                :vuelidateObj="$v.form.mobile"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12" md="12">
              <Input
                :label="$lang.message_text"
                :placeholder="$lang.message_text"
                :value="form.text"
                name="text"
                id="text"
                type="textarea"
                :minLength="lengthNumber3"
                :state="$v.form.text.$dirty ? !$v.form.text.$error : null"
                :vuelidateObj="$v.form.text"
                @input="input"
                @focus="resetValidation"
                @blur="checkValidation"
              />
            </b-col>
            <b-col cols="12" md="12" class="margin-bottom-16">
              <AttachmentWotUploader
                :label="$lang.attachment_upload"
                resourceName="contact_us"
                :resourceValue="id"
                :uploaderConfig="uploaderConfig"
                uploaderName="contact_us"
                :hasCrop="false"
                :aspectRatio="1 / 1"
                @hasFile="updateHasFile"
                @success="updateSuccessUploaded"
              />
            </b-col>
          </b-row>
        </template>
        <template #button>
          <b-row>
            <b-col cols="12" md="12">
              <Button
                class="w-100"
                contentClass="justify-content-center"
                variant="primary"
                :text="$lang.submit"
                :loading="loading"
                type="submit"
                @click="submit"
              />
            </b-col>
          </b-row>
        </template>
      </AuthWrapper>
    </b-form>
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper, Alert } from "@/components/re-design";
import AttachmentWotUploader from "@/components/re-design/uploader/AttachmentWotUploader.vue";
import { Input, Button } from "@/components/re-design/forms";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { copy, goToRoute } from "@/shared/utils";
import { contactUs } from "@/modules/auth/services";

export default {
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Alert,
    Input,
    AttachmentWotUploader,
    Button,
  },
  validations() {
    return {
      form: {
        name: {
          required,
          minLength: minLength(this.lengthNumber3),
          maxLength: maxLength(this.lengthNumber64),
        },
        family: {
          required,
          minLength: minLength(this.lengthNumber3),
          maxLength: maxLength(this.lengthNumber64),
        },
        mobile: {
          required,
          numeric,
          minLength: minLength(this.lengthNumber11),
          maxLength: maxLength(this.lengthNumber11),
        },
        text: {
          required,
          minLength: minLength(this.lengthNumber3),
        },
      },
    };
  },
  data() {
    return {
      loading: false,
      form: {
        name: null,
        family: null,
        mobile: null,
        text: null,
      },
      id: null,
      trackingCode: null,
      successUploaded: false,
      hasFile: false,
      uploaderConfig: {
        // hard code data for uploader without token
        uploaders: [
          {
            name: "contact_us",
            items: [22],
          },
        ],
        attachments: [
          {
            id: 22,
            category_name: "attachment_type_ticket",
            max_upload: 1,
            types: [
              {
                ext: ["jpg", "jpeg", "png", "bmp"],
                title: "عکس",
                max_size: 10240,
                min_res: 100,
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    pathOr,
    copy,
    goToRoute,
    goToLogin() {
      goToRoute("auth", {}, {}, false);
    },
    updateHasFile(value) {
      this.hasFile = value;
    },
    updateSuccessUploaded(value) {
      this.successUploaded = value;
      this.loading = false;
      this.resetForm();
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const name = this.form.name;
        const family = this.form.family;
        const mobile = this.form.mobile;
        const text = this.form.text;
        const response = await contactUs(name, family, mobile, text);
        const { id, trackingCode, message } = response;
        this.id = id;
        this.trackingCode = trackingCode;
        if (!this.hasFile) {
          this.$notify.success(message);
          this.updateSuccessUploaded(true);
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = this.hasFile;
      }
    },
  },
};
</script>
